import { NgModule } from '@angular/core';
import { Route, RouterModule, Routes, UrlSegment, UrlSegmentGroup } from '@angular/router';
import { HomePageComponent } from './pages/home-page/home-page.component';
import { SuccessPageComponent } from './pages/success-page/success-page.component';
import { FailedPageComponent } from './pages/failed-page/failed-page.component';
import { ServicePageComponent } from './pages/service-page/service-page.component';
import { LayoutPageComponent } from './pages/layout-page/layout-page.component';
import { HomeGuard } from './guards/home.guard';
import { TracingPageComponent } from './pages/tracing-page/tracing.component';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { MasGarantiaComponent } from './mas-garantia-module/pages/mas-garantia/mas-garantia.component';
import { FindByTicketComponent } from './mas-garantia-module/pages/find-by-ticket/find-by-ticket.component';
import { environment } from 'src/environments/environment';
import { PrivacyPolicyComponent } from './mas-garantia-module/pages/privacy-policy/privacy-policy.component';

const routes: Routes = [
  // Mas Garantia 
  { 
    matcher: (segments:UrlSegment[], group: UrlSegmentGroup,route: Route) =>{

      if(environment.masGarantiaUrl.includes(location.origin) && segments.length === 0){
      return {consumed: segments }
    }
    return null;
    },
    component: MasGarantiaComponent
  },
  { 
    matcher: (segments:UrlSegment[], group: UrlSegmentGroup,route: Route) =>{

      const isFindByTicket = segments.some(seg => seg.path === 'findbyticket');
      if(environment.masGarantiaUrl.includes(location.origin) && isFindByTicket){
        return {consumed: segments }
      }
      return null;
    },
    component: FindByTicketComponent
  },
  { 
    matcher: (segments:UrlSegment[], group: UrlSegmentGroup,route: Route) =>{

      const isPrivacyPolicy = segments.some(seg => seg.path === 'privacy-policy');
      if(environment.masGarantiaUrl.includes(location.origin) && isPrivacyPolicy){
        return {consumed: segments }
      }
      return null;
    },
    component: PrivacyPolicyComponent
  },
  //{ path: 'privacy-policy', pathMatch: 'full', component: PrivacyPolicyComponent },

  // PIF
  {
    matcher: (segments:UrlSegment[], group: UrlSegmentGroup,route: Route) =>{

      if(environment.pifUrl.includes(location.origin) && segments.length === 0 ){
        return { consumed: segments };
      }
      return null;
    },
    component: LayoutPageComponent, 
    canActivate:[HomeGuard]
  },
  {
    matcher: (segments:UrlSegment[], group: UrlSegmentGroup,route: Route) =>{
      
      const isService = segments.some(seg => seg.path === 'service');
      if(environment.pifUrl.includes(location.origin) && isService){
        let parameters: any;
        if(segments.length === 2){
          parameters = { deviceId: new UrlSegment( segments[1].path,{})}
          return { consumed: segments, posParams: parameters }
        }
        return { consumed: segments};
      }
      return null;
    },
    component: ServicePageComponent
  },
  {
    matcher: (segments:UrlSegment[], group: UrlSegmentGroup,route: Route) =>{
    
      const isFailed = segments.some(seg => seg.path === 'failed');
      if(environment.pifUrl.includes(location.origin) && isFailed){
        return { consumed: segments};
      }
      return null;
    },
    component: FailedPageComponent
  },
  {
    matcher: (segments:UrlSegment[], group: UrlSegmentGroup,route: Route) =>{
     
      const isSuccess = segments.some(seg => seg.path === 'success');
      if(environment.pifUrl.includes(location.origin) && isSuccess){
        let parameters = {
          serviceNumber: new UrlSegment(segments[1].path, {}),
          status: new UrlSegment(segments[2].path, {})
        }
        return { consumed: segments, posParams: parameters };
      }
      return null;
    },
    component: SuccessPageComponent, 
  },
  {
    matcher: (segments:UrlSegment[], group: UrlSegmentGroup,route: Route) =>{
     
      const isTracking = segments.some(seg => seg.path === 'tracking');
      if(environment.pifUrl.includes(location.origin) && isTracking){
        let parameters = {
          deviceId: new UrlSegment(segments[1].path, {}),
          claimNumber: new UrlSegment(segments[2].path, {})
        }
        return { consumed: segments, posParams: parameters };
      }
      return null;
    },
    component: TracingPageComponent, 
  },
];

export function HttpLoaderFactory(http: HttpClient) {

  return new TranslateHttpLoader(http, '/assets/languajes/liverpool/', '.json');

}


@NgModule({
  imports: [
    RouterModule.forRoot(routes),
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  exports: [RouterModule,
    TranslateModule]
})
export class AppRoutingModule { }
